module.exports = __webpack_public_path__ + "static/media/spinner-inc.cb09a0d1.svg";